import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import Header from '../InitialPage/Sidebar/Header';
import Sidebar from '../InitialPage/Sidebar/Sidebar';
import { pagesRoute, posRoutes, publicRoutes } from './router.link';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ToastMessage from '../feature-module/components/toast-message';
import 'react-toastify/dist/ReactToastify.css';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import ProtectedRoute from '../core/utils/ProtectedRoute';
import AutoLogout from '../core/utils/AutoLogout';
import { all_routes } from './all_routes';
import { isAuthenticated } from '../core/utils/tokenUtils';
import { usePermission } from '../core/utils/PermissionContext';
import LoadingSpinner from '../InitialPage/Sidebar/LoadingSpinner';

import AuthCallback from '../auth/AuthCallback';

const AllRoutes = () => {
  const HeaderLayout = () => {
    const headerVisible = useSelector(isHeaderVisible);

    return (
      <div className={`main-wrapper ${headerVisible ? '' : 'header-collapse'}`}>
        <Header />
        <Sidebar />
        <AutoLogout />
        <Outlet />
      </div>
    );
  };

  const Authpages = () => {
    const headerVisible = useSelector(isHeaderVisible);
    return (
      <div className={headerVisible ? '' : 'header-collapse'}>
        <Outlet />
      </div>
    );
  };

  const Pospages = () => {
    const headerVisible = useSelector(isHeaderVisible);

    return (
      <div className={`main-wrapper ${headerVisible ? '' : 'header-collapse'}`}>
        <Header />
        <Sidebar />
        <AutoLogout />
        <Outlet />
        <ToastMessage />
      </div>
    );
  };

  // Root redirect: signed-in users go to their landing page from /api/access/me
  // (first authorized page by Operations_Page.LandingPriority), otherwise to sign-in.
  const RootRedirect = () => {
    const { accounts } = useMsal();
    const { me, status, landingRoute } = usePermission();
    const authenticated = isAuthenticated();
    const msalAuthenticated = accounts && accounts.length > 0;

    if (!authenticated && !msalAuthenticated) {
      return <Navigate to={all_routes.signin} replace />;
    }
    if (!me) {
      if (status === 'error' || (status === 'idle' && !msalAuthenticated)) {
        return <Navigate to={all_routes.noaccess} replace state={{ reason: 'error' }} />;
      }
      return <LoadingSpinner />;
    }
    return <Navigate to={landingRoute || all_routes.noaccess} replace />;
  };

  return (
    <div className="root-body">
      <Routes>
        {/* Auth Callback Route - Must be before RootRedirect */}
        <Route path={all_routes.authcallback} element={<AuthCallback />} />

        {/* Root route redirect based on auth */}
        <Route path="/" element={<RootRedirect />} />

        {/* Public routes (no auth required) */}
        <Route path={'/'} element={<Authpages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        {/* Protected routes (auth required) */}
        <Route path="/pos" element={
          <ProtectedRoute>
            <Pospages />
          </ProtectedRoute>
        }>
          {posRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        <Route path={'/'} element={
          <ProtectedRoute>
            <HeaderLayout />
          </ProtectedRoute>
        }>
          {publicRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
      <ToastMessage />
    </div>
  );
};
export default AllRoutes;
